import { Component, inject } from '@angular/core';
import { PasButtonRoundColor, PasButtonRoundComponent } from '@porsche-aftersales/frontend-toolbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { checkReadRights } from '../../../services/booking/recourse-booking-functions';
import { UserService } from '../../../services/user-service/user.service';

@Component({
  selector: 'app-button-details-renderer',
  templateUrl: './button-details-renderer.component.html',
  styleUrls: ['./button-details-renderer.component.scss'],
  imports: [PasButtonRoundComponent],
})
export class ButtonDetailsRendererComponent implements ICellRendererAngularComp {
  private readonly userService = inject(UserService);

  private params: any;

  public agInit(params): void {
    this.params = params;
  }

  public refresh(): boolean {
    return true;
  }

  public onClick($event): void {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
      };
      this.params.onClick(params);
    }
  }

  public isButtonDetailsVisible(): boolean {
    return checkReadRights(this.userService.getRights());
  }

  public readonly pasButtonRoundColor = PasButtonRoundColor;
}
